import { ReportType } from "./report-types";

export enum ReportCategory {
  BASE = 'base',
  VEHICLE = 'vehicle',
  CHECKLIST = 'checklist',
  EVENT = 'event',
  DEPRECATED = 'deprecated'
}

export const reportTypesByCategory: Record<ReportCategory, ReportType[]> = {
  [ReportCategory.BASE]: [
    ReportType.REPORTE_POSICION,
    ReportType.REPORTE_EXCESOS_VELOCIDAD_DURACION_TOLERANCIA_NIVEL_RIESGO,
    ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_DURACION_TOLERANCIA_NIVEL_RIESGO,
    ReportType.REPORTE_EXCESOS_VELOCIDAD_POR_NIVEL,
    ReportType.REPORTE_COORDENADAS_GEOCERCAS,
    ReportType.REPORTE_COORDENADAS_GEOPUNTOS,
    ReportType.REPORTE_COORDENADAS_GEOCERCAS_CIRCULARES,
    ReportType.REPORTE_ATENCION_EVENTOS,
    ReportType.REPORTE_CHECKLIST,
    ReportType.REPORTE_RECORRIDO,
    ReportType.REPORTE_OPERATIVIDAD_EQUIPO,
    ReportType.REPORTE_COMBUSTIBLE_RESUMEN,
    ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_NIVEL,
    ReportType.REPORTE_PRIMER_MOVIMIENTO,
  ],
  [ReportCategory.VEHICLE]: [
    ReportType.REPORTE_PARADAS_MOVIMIENTOS,
    ReportType.REPORTE_EXCESOS_VELOCIDAD_LIMITE_PERSONALIZADO,
    ReportType.REPORTE_GENERAL,
    ReportType.REPORTE_EVENTOS,
    ReportType.REPORTE_EVENTOS_INTERNO,
    ReportType.REPORTE_ENTRADA_SALIDA_GEOCERCAS,
    ReportType.REPORTE_COMBUSTIBLE_GENERAL,
    ReportType.REPORTE_RESUMEN_POR_DIA_NUEVO,
    ReportType.REPORTE_RELENTI,
    ReportType.REPORTE_ESTADO_TRANSMISION_EVENTOS,
    ReportType.REPORTE_CONDUCTORES_ENROLADOS,
    ReportType.REPORTE_EVENTOS_FORMATO_PAXI,
    ReportType.REPORTE_PARADAS_MOVIMIENTOS_NUEVO,
    ReportType.REPORTE_PARADAS_MOVIMIENTOS_ENHANCED,
    //ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_NIVEL,
  ],
  [ReportCategory.CHECKLIST]: [
    ReportType.REPORTE_CHECKLIST
  ],
  [ReportCategory.EVENT]: [
    ReportType.REPORTE_MONITOREO_CANTIDAD_EVENTOS_POR_UNIDAD
  ],
  [ReportCategory.DEPRECATED]: []
};
